<template>
    <!-- Company Branding -->
    <v-layout row wrap v-if="company" height="100px" class="mx-2 py-4">
        <v-flex xs12 v-if="company.logo_url">
             <v-img :src="company.logo_url" height="80px" contain></v-img>
        </v-flex>
        <v-flex xs12 v-else text-xs-center>
            <div class="headline font-weight-bold primary--text">
                {{ company.title }}
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name:"CompanyBranding",
    props:{
        company:{
            type:Object,
            default:null
        }
    }

}
</script>
